import { render, staticRenderFns } from "./scan-reader.vue?vue&type=template&id=ff9a11d6&scoped=true&"
import script from "./scan-reader.vue?vue&type=script&lang=js&"
export * from "./scan-reader.vue?vue&type=script&lang=js&"
import style0 from "./scan-reader.vue?vue&type=style&index=0&id=ff9a11d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9a11d6",
  null
  
)

export default component.exports